import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';

var _this = this;

import isRequired from '../utils/isRequired';
/**
 * EventListener is used to watch events on the blockchain for a set of contracts.
 * Handlers for specific events can be added. When an event log is found EventListener
 * will fire all handlers registered for the contract.
 */

var EventListener = function EventListener() {
  _classCallCheck(this, EventListener);
};

EventListener.getEventLogs = function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var contractInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractInstance');
    var eventName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('eventName');
    var fromBlock = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var toBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'latest';
    var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', contractInstance.getPastEvents(eventName, {
              filter: filters,
              fromBlock: fromBlock,
              toBlock: toBlock
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function () {
    return _ref.apply(this, arguments);
  };
}();

export default EventListener;